import { Component, inject, input, linkedSignal } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_CARD, KENDO_EXPANSIONPANEL } from '@progress/kendo-angular-layout';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';
import { FormInstanceDetailedDto } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { SortPipe } from '@unity/pipes/sort.pipe';
import { CollapseStateService, FormInstanceListType } from '@unity/services/collapse-state.service';
import { SortConfig } from '@unity/utils/types';
import { CardFormInstanceSharedComponent } from '../card-form-instance-shared/card-form-instance-shared.component';

@Component({
  selector: 'unity-list-form-instance-shared',
  standalone: true,
  imports: [KENDO_LISTVIEW, KENDO_BUTTON, KENDO_CARD, KENDO_EXPANSIONPANEL, SortPipe, CardFormInstanceSharedComponent, TypedDirective],
  templateUrl: './list-form-instance-shared.component.html',
  styleUrl: './list-form-instance-shared.component.scss',
})
export class ListFormInstanceSharedComponent {
  private readonly collapseStateService = inject(CollapseStateService);

  public readonly $agreementId = input.required<number>({ alias: 'agreementId' });
  public readonly $formInstanceListType = input.required<FormInstanceListType>({ alias: 'formInstanceListType' });
  public readonly $formInstances = input.required<FormInstanceDetailedDto[]>({ alias: 'formInstances' });
  public readonly $headerText = input.required<string>({ alias: 'headerText' });

  public readonly $noRecordsText = input<string>('No Items.', { alias: 'noRecordsText' });

  public readonly $highlightedRecordId = input.required<number | undefined>({ alias: 'highlightedRecordId' });

  protected sortConfigs: SortConfig[] = [
    {
      field: 'due_date',
      dir: 'asc',
    },
    {
      field: 'id',
      dir: 'asc',
    },
  ];

  private getInitialState(agreementId: number, formInstanceListType: FormInstanceListType) {
    const prefs = this.collapseStateService.getPreferences(agreementId);
    if (prefs) {
      return prefs[formInstanceListType];
    }
    return false;
  }

  protected readonly $isCollapsed = linkedSignal(() => {
    const agreementId = this.$agreementId();
    const formInstanceListType = this.$formInstanceListType();

    return this.getInitialState(agreementId, formInstanceListType);
  });

  protected toggleCollapse = (isCollapsed: boolean) => {
    const agreementId = this.$agreementId();
    const formInstanceListType = this.$formInstanceListType();

    this.collapseStateService.setPreferences(agreementId, formInstanceListType, isCollapsed);
    this.$isCollapsed.set(isCollapsed);
  };

  protected handleScrollToEvent = () => {
    this.toggleCollapse(false);
  };
}
